import { API_BASE_URL } from "api/config";

/**
 * The link handed out for a public tree, and the image a preview of it shows.
 *
 * Both live on the API rather than the web app because this app is a static single-page bundle: its
 * Open Graph tags are written by JavaScript, and the scrapers that build link previews do not run
 * JavaScript. They read only the generic tags in `index.html`, so every shared tree previews
 * identically. The API serves a document those scrapers can actually read, and redirects a person who
 * opens it to the tree here.
 *
 * Only for public trees. A non-public tree is served the generic site card by design, so sharing its
 * canonical URL is both more honest and more useful to the member who can open it.
 */
export const getTreeShareUrl = (treeId: string): string => `${API_BASE_URL}/s/${treeId}`;

/** The 1200x630 preview image rendered for a public tree. */
export const getTreeShareCardUrl = (treeId: string): string => `${API_BASE_URL}/s/${treeId}/card.png`;
